import Vue from 'vue';
import Vuex from 'vuex';
import { argumentsModule } from '@/store/modules/argumentsModule';
import { commentsModule } from '@/store/modules/commentsModule';
import { displayModule } from '@/store/modules/displayModule';
import { documentsModule } from '@/store/modules/documentsModule';
import { mainModule } from '@/store/modules/mainModule';
import { routerModule } from '@/store/modules/routerModule';
import { sectionsModule } from '@/store/modules/sectionsModule';
import { usersModule } from '@/store/modules/usersModule';
import { votingModule } from '@/store/modules/votingModule';
import { changeEventsModule } from '@/store/modules/changeEventsModule';
import { RootState } from '@/store/types';

const vueAppData = process.env.VUE_APP_DATA;
const indexDecorator = require(`../decorators/${vueAppData}Decorators/${vueAppData}IndexDecorator`).default;
Vue.use(Vuex);

const storeObj:any = {
  state: {
    version: '1.0.0'
  },
  modules: {
    routerModule,
    displayModule,
    votingModule,
    sectionsModule,
    argumentsModule,
    mainModule,
    usersModule,
    commentsModule,
    changeEventsModule,
    documentsModule
  },
  plugins: []
};
indexDecorator(storeObj);
console.log('Index Store Object: ', storeObj);
export const store = new Vuex.Store<RootState>(storeObj);
